import type { ReactNode } from "react";

interface Props {
    children?: ReactNode;
}

const Providers = ({ children }: Readonly<Props>) => <>{children}</>;

export default Providers;
